export default __webpack_public_path__ + "static/media/hours_of_op.064f149c.svg";